import { TextArea } from "src/designsystem/TextArea/TextArea";

import { ForwardedRef, forwardRef } from "react";
import { useController } from "react-hook-form";
import { FormTextAreaProps } from "./Form.types";
import FormField, { useFormField } from "./FormField/FormField";
import { TextAreaRef } from "antd/lib/input/TextArea";

export const FormTextArea = forwardRef(
  (props: FormTextAreaProps, ref: ForwardedRef<TextAreaRef>) => {
    const { formFieldProps, childProps } = useFormField(props);
    const { field } = useController({ name: childProps.name });

    return (
      <FormField {...formFieldProps}>
        <TextArea {...childProps} {...field} ref={ref} />
      </FormField>
    );
  }
);
